export default function Pricing() {
  const plans = [
    {
      name: 'Free', price: '$0', billing: 'forever', subtitle: 'Perfect to get started',
      features: ['Application Tracker (up to 50 jobs)','Chrome Extension (capture only)','Resume Builder (1 template)','Job Feed (manual search)','Playbook access','Watchlist (up to 10 companies)','Interview calendar'],
      cta: 'Get Started Free', ctaLink: 'https://app.jobos.dev', highlighted: false, primary: false
    },
    {
      name: 'Pro', price: '$12', billing: 'month', billingNote: 'or $8/mo billed annually', subtitle: 'For serious job seekers', badge: 'MOST POPULAR',
      features: ['Everything in Free','Unlimited applications','✦ AI Resume Tailoring (unlimited)','✦ Application Copilot (match score + cover letter)','ATS Autofill (all 9+ platforms)','AI Job Agents (up to 5 agents)','Connections CRM (unlimited)','Watchlist (unlimited companies)','✦ Growth Engine + LinkedIn AI posts','Analytics dashboard','Priority support'],
      cta: 'Start Pro Free — 7 Days', ctaLink: 'https://app.jobos.dev/pro', highlighted: true, primary: true
    },
    {
      name: 'Teams', price: 'Coming Soon', billing: '', subtitle: 'For recruiters and career coaches',
      features: ['Help clients manage their search','Team analytics','Client workspaces','Bulk resume tailoring'],
      cta: 'Join Waitlist', ctaLink: 'https://app.jobos.dev/waitlist', highlighted: false, primary: false, comingSoon: true
    }
  ];

  return (
    <section id="pricing" className="py-[120px] bg-white dark:bg-[#0A0E1A]">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="text-center mb-20">
          <div className="text-[#818CF8] text-sm font-mono uppercase tracking-wider mb-4">SIMPLE PRICING</div>
          <h2 className="text-5xl font-extrabold text-gray-900 dark:text-white mb-6">Start free. Upgrade when you're ready.</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-[1200px] mx-auto mb-8">
          {plans.map((plan, index) => (
            <article
              key={index}
              className={`bg-gray-50 dark:bg-[#141828] rounded-2xl p-10 transition-all duration-200 ${plan.comingSoon ? 'opacity-60' : 'hover:-translate-y-1'} ${plan.highlighted ? 'border-2 border-[#6366F1] shadow-lg' : 'border border-gray-200 dark:border-[#2D3148] hover:border-[#6366F1]'}`}
            >
              {plan.badge && (
                <div className="mb-4">
                  <span className="inline-block px-3 py-1 bg-[#10B981] text-white text-xs font-bold uppercase rounded-full">{plan.badge}</span>
                </div>
              )}
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">{plan.name}</h3>
              <p className="text-gray-500 dark:text-[#94A3B8] text-sm mb-6">{plan.subtitle}</p>
              <div className="mb-2">
                <span className="text-[56px] font-extrabold text-gray-900 dark:text-white leading-none">{plan.price}</span>
                {plan.billing && <span className="text-gray-500 dark:text-[#94A3B8] text-lg"> / {plan.billing}</span>}
              </div>
              {plan.billingNote && <p className="text-gray-500 dark:text-[#94A3B8] text-sm mb-8">{plan.billingNote}</p>}
              {!plan.billingNote && <div className="mb-8"></div>}
              <ul className="space-y-3 mb-10">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <span className="text-[#10B981] text-base mt-0.5">✓</span>
                    <span className="text-gray-700 dark:text-[#F8FAFC] text-base">{feature}</span>
                  </li>
                ))}
              </ul>
              <a
                href={plan.ctaLink}
                className={`w-full h-12 rounded-lg text-base font-semibold flex items-center justify-center transition-all duration-200 whitespace-nowrap cursor-pointer ${plan.primary ? 'bg-[#6366F1] text-white hover:-translate-y-0.5 hover:shadow-lg' : 'bg-transparent border border-gray-300 dark:border-[#2D3148] text-gray-900 dark:text-white hover:border-[#6366F1]'} ${plan.comingSoon ? 'pointer-events-none' : ''}`}
              >
                {plan.cta}
              </a>
            </article>
          ))}
        </div>
        <p className="text-center text-gray-500 dark:text-[#94A3B8] text-base">All plans include the Chrome Extension. No credit card required to start.</p>
      </div>
    </section>
  );
}
